import Navbar from "../components/Navbar";
import HeroSection from "../components/HeroSection";
import TokenomicsSection from "../components/TokenomicsSection";
import StakingSection from "../components/StakingSection";
import MnftsSection from "../components/MnftsSection";
import FaqsSection from "../components/FaqsSection";
import TermsSection from "../components/TermsSection";
import BroPaperSection from "../components/BroPaperSection";

const Index = () => {
  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <HeroSection />
      
      {/* About Token Section */}
      <section id="about-token" className="py-24 px-4 bg-background">
        <div className="max-w-6xl mx-auto text-center">
          <h2 className="text-5xl font-bold text-foreground mb-8">
            ABOUT THE <span className="text-secondary">$TOP1 TOKEN</span>
          </h2>
          
          <div className="space-y-8 max-w-4xl mx-auto">
            <div className="flex items-center space-x-4 mb-8">
              <div className="w-16 h-16 bg-secondary rounded-full flex items-center justify-center flex-shrink-0">
                <span className="text-2xl">🪙</span>
              </div>
              <div className="text-left">
                <h3 className="text-2xl font-bold text-foreground mb-2">Introduction</h3>
                <p className="text-xl text-muted-foreground">"$TOP1 get your shit together."</p>
              </div>
            </div>

            <div className="flex items-center space-x-4 mb-8">
              <div className="w-16 h-16 bg-secondary rounded-full flex items-center justify-center flex-shrink-0">
                <span className="text-2xl">🎯</span>
              </div>
              <div className="text-left">
                <h3 className="text-2xl font-bold text-foreground mb-2">Mission</h3>
                <p className="text-xl text-muted-foreground">
                  $TOP1 fuels meme-native coordination — no investors, no owners, no shortcuts. 
                  Just meme energy and aligned community action.
                </p>
              </div>
            </div>

            <div className="flex items-center space-x-4">
              <div className="w-16 h-16 bg-secondary rounded-full flex items-center justify-center flex-shrink-0">
                <span className="text-2xl">⚡</span>
              </div>
              <div className="text-left">
                <h3 className="text-2xl font-bold text-foreground mb-2">Why Will $TOP1 Succeed?</h3>
                <p className="text-xl text-muted-foreground">
                  Because the bros build, meme, and ship. That's it.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <TokenomicsSection />
      <StakingSection />
      <MnftsSection />
      <FaqsSection />
      <TermsSection />
      <BroPaperSection />
    </div>
  );
};

export default Index;